import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgApprove = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 10,
		cy: 10,
		r: 10,
		fill: "#5ad83a"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.8911 7.08203L8.54384 12.4293L6.11328 9.9987",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgApprove;
